import { GrowthBook } from '@growthbook/growthbook-react'
import axios, { AxiosError, AxiosResponse } from 'axios'
import axiosRetry from 'axios-retry'

axiosRetry(axios, {
	retries: 3,
	retryDelay: (retryCount) => {
		console.log(`retry attempt: ${retryCount}`)
		return retryCount * 2000
	},
})

export const useGrowthbook = () => {
	const experimentEndpoint = `${process.env.NEXT_PUBLIC_BACKEND_URL}/hotels/experiment?api-key=${process.env.NEXT_PUBLIC_API_KEY}`

	const growthbook = new GrowthBook({
		enableDevMode: process.env.NODE_ENV !== 'production',
		apiHost: 'https://cdn.growthbook.io/',
		clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_API_KEY,
		trackingCallback: (experiment, result) => {
			// console.log('tracking callback called')
			axios
				.post(
					experimentEndpoint,
					{
						experiment_id: experiment.key,
						variation_id: result.variationId.toString(),
						event_timestamp: new Date().toISOString(),
					},
					{
						withCredentials: true,
					}
				)
				.then((response: AxiosResponse) => {
					console.log(JSON.stringify('experiment viewed', response.data))
				})
				.catch((error: AxiosError) => {
					console.log(error)
				})
		},
	})

	growthbook.init()

	const gbCallback = (params: { uid: string }) => {
		const { uid } = params

		growthbook.setAttributes({
			id: uid,
		})
	}
	return { growthbook, gbCallback }
}
